import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 13.5C13.3807 13.5 14.5 12.3807 14.5 11C14.5 9.61929 13.3807 8.5 12 8.5C10.6193 8.5 9.5 9.61929 9.5 11C9.5 12.3807 10.6193 13.5 12 13.5Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.0711 3.42893C15.1658 -0.476311 8.83418 -0.476311 4.92893 3.42893C1.02369 7.33418 1.02369 13.6658 4.92893 17.5711L4.95663 17.5987L10.3322 22.9743C11.2534 23.8954 12.7468 23.8954 13.6679 22.9743L19.0711 17.5711C22.9763 13.6658 22.9763 7.33415 19.0711 3.42893ZM5.98959 4.48959C9.30905 1.17014 14.691 1.17014 18.0104 4.48959C21.3298 7.80903 21.3299 13.191 18.0105 16.5104L12.6073 21.9136C12.2719 22.249 11.7282 22.249 11.3929 21.9136L6.01526 16.536L6.01322 16.5339L5.98959 16.5104C2.67014 13.191 2.67014 7.80905 5.98959 4.48959Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgLocation;
